var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobileTop",staticStyle:{"padding-top":"50px"}},[_c('div',[_c('Schedule',{attrs:{"id":_vm.id,"fields":_vm.fields,"data":_vm.data,"code":_vm.code,"config":_vm.config,"loggedin":_vm.loggedin,"course":_vm.course,"idName":_vm.idName,"future":_vm.future,"past":_vm.past}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }